/// <amd-module name="typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils" />

/// <reference path="../../../typings/typeahead/ExpediaSuggestServiceRequestGenerator.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

export function addFeatureFlag(
        featureFlag: string,
        configuration: IStripingConfiguration[],
        params: ISuggestServiceQueryParams,
        context: IContext,
        options?: any): JQueryPromise<ISuggestServiceQueryParams> {
    let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
    if (typeof params !== "undefined") {
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                params.features = params.features && params.features.length &&
                params.features.push ? params.features || [] : [];
                if (shouldExecute && params.features.indexOf(featureFlag) < 0) {
                    params.features.push(featureFlag);
                }
            })
            .always(() => {
                deferred.resolve(params);
            });

    } else {
        deferred.resolve(params);
    }
    return deferred.promise();
}
